import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sparkles, ArrowDown } from 'lucide-react';
import ReactGA from 'react-ga4';

export default function HeroLaunchCapsule({
  appName = 'all', // 'all' | 'SmartAssessment' | 'SmartJournal'
  className = ''
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const isSA = appName === 'SmartAssessment' || location.pathname.includes('smart-assessments');
  const isSJ = appName === 'SmartJournal' || location.pathname.includes('smart-journals');

  let badgeText = "APPS NOW LIVE";
  let mainText = "SmartAssessment & SmartJournal Apps Live on iOS & Android!";
  let buttonText = "Download Apps";

  if (isSA) {
    badgeText = "APP LAUNCHED";
    mainText = "SmartAssessment App Available on App Store & Play Store!";
    buttonText = "Get App";
  } else if (isSJ) {
    badgeText = "APP LAUNCHED";
    mainText = "SmartJournal App Available on App Store & Play Store!";
    buttonText = "Get App";
  }

  const handleScrollOrNavigate = (e) => {
    e.preventDefault();
    try {
      ReactGA.event({
        category: 'HeroCapsule',
        action: 'click_launch_capsule',
        label: appName
      });
    } catch { }

    const el = document.getElementById('mobile-apps');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#mobile-apps');
      setTimeout(() => {
        const target = document.getElementById('mobile-apps');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }, 300);
    }
  };

  return (
    <div
      onClick={handleScrollOrNavigate}
      className={`inline-flex flex-wrap sm:flex-nowrap items-center justify-center gap-2 sm:gap-3.5 max-w-[94vw] sm:max-w-max px-3 sm:px-4 py-2 sm:py-2.5 rounded-xl bg-[#050505] opacity-100 border-2 border-[#22c55e] shadow-[0_0_30px_rgba(34,197,94,0.45)] hover:border-[#4ade80] hover:shadow-[0_0_40px_rgba(34,197,94,0.7)] transition-all duration-300 transform hover:scale-105 cursor-pointer group select-none ${className}`}
    >
      {/* Opaque High-Visibility Badge */}
      <span className="shrink-0 inline-flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-0.5 sm:py-1 rounded-md bg-[#0d2d17] border border-[#22c55e] text-[#4ade80] text-[10px] sm:text-xs font-black uppercase tracking-wider shadow-[0_0_12px_rgba(34,197,94,0.4)]">
        <Sparkles className="w-3 sm:w-3.5 h-3 sm:h-3.5 text-[#4ade80] animate-pulse" />
        <span>{badgeText}</span>
      </span>

      {/* High-Contrast Bold Headline */}
      <span className="text-[11px] sm:text-xs md:text-sm font-extrabold text-white tracking-wide text-center leading-tight">
        {mainText}
      </span>

      {/* Vivid Solid Electric Green CTA Button */}
      <span className="shrink-0 inline-flex items-center gap-1 px-2.5 sm:px-3 py-1 text-[11px] sm:text-xs font-black text-black bg-[#22c55e] group-hover:bg-[#4ade80] rounded-md shadow-[0_0_16px_rgba(34,197,94,0.6)] transition-all duration-300">
        <span>{buttonText}</span>
        <ArrowDown className="w-3 sm:w-3.5 h-3 sm:h-3.5 text-black stroke-[3]" />
      </span>
    </div>
  );
}
